import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from "react-router-dom";
import './Header.css'
import Permissions from '../../shared/components/Permissions';
import FormikSelectField from '../../shared/components/FormikSelectField';
import { usePortal } from '../../contexts/PortalContext';
 import { useDispatch, useSelector } from 'react-redux';
import { loadCompanyDataRequest, loadCompanyUserAddDataRequest, loadCompanyUserGetDataRequest } from '../company/redux/Actions';
import { setProfileView } from '../power-bi-portal/redux/Actions';
import useDeviceDetect from '../../hooks/useDeviceDetect';
let logoPath = "/OPERIS_LOGO.png";

const Header = ({ toggleMenu }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const { portalMode, isMDSMode, isReportMode, isReportMenuCollapsed } = usePortal();
    const { isMobile } = useDeviceDetect();
    const [quickAppsOpen, setQuickAppsOpen] = useState(false);

    let empInfo = JSON.parse(localStorage.getItem('employee'));
    let securityTab = false;
    if (empInfo?.role === "admin") {
        securityTab = true;
    }
    let emp_no = JSON.parse(localStorage.getItem("emp_no"));
    const isAdmin = empInfo?.role === "admin";
    const ticketemployees = ["134321","105729"];
    const hasTicketAccess =  isAdmin || empInfo?.role !== "hc_sales"
    const seatReservation = Permissions(emp_no, 'Seat Reservation');
    const dispatch = useDispatch();
    const { companies } = useSelector((store) => store.company);
    const { userCompany } = useSelector((store) => store.company) || {};
    const [companyMenuOpen, setCompanyMenuOpen] = useState(false);

    // emp_company is now an ARRAY of company ids (backend company_id is INTEGER[])
    const getStoredCompanyIds = () => {
        try {
            const raw = localStorage.getItem('emp_company');
            const parsed = raw ? JSON.parse(raw) : [];
            return Array.isArray(parsed) ? parsed : [];
        } catch {
            return [];
        }
    };

    const handleClickOutside = (e) => {
        if (!e.target.closest('.company-select-box') && !e.target.closest('.quick-links-box')) {
            setCompanyMenuOpen(false);
            setQuickAppsOpen(false);
        }
    };

    const [emp_company, setEmpCompany] = useState(getStoredCompanyIds());
    // Draft selection while the dropdown is open — only committed on "Apply"
    const [pendingCompanyIds, setPendingCompanyIds] = useState(getStoredCompanyIds());

    useEffect(() => {
        dispatch(loadCompanyDataRequest());
        dispatch(loadCompanyUserGetDataRequest());
    }, []);

    useEffect(() => {
        const companyIds = userCompany?.data?.company_id;
        if (Array.isArray(companyIds)) {
            localStorage.setItem("emp_company", JSON.stringify(companyIds));
            setEmpCompany(companyIds);
        }
    }, [userCompany]);

    const selectedCompanies = companies?.filter(c => emp_company.includes(c.id)) || [];

    // Show comma-separated company names instead of a "N companies" count
    const companySelectedLabel = selectedCompanies.length === 0
        ? "Company"
        : selectedCompanies.map(c => c.company_name).join(", ");

    const openCompanyMenu = () => {
        setPendingCompanyIds(emp_company); // seed draft with current committed selection
        setCompanyMenuOpen(true);
    };

    const handleApplyCompanies = () => {
        localStorage.setItem("emp_company", JSON.stringify(pendingCompanyIds));
        setEmpCompany(pendingCompanyIds);
        dispatch(loadCompanyUserAddDataRequest({ "company_id": pendingCompanyIds }));
        setCompanyMenuOpen(false);
    };

    const handleCancelCompanies = () => {
        setPendingCompanyIds(emp_company); // discard draft changes
        setCompanyMenuOpen(false);
    };


    // Determine if we're in the ticketing section
    const isTicketing = location.pathname.startsWith("/tickets");
    const handleLogoClick = () => {
        navigate("/dashboard");
    };

    useEffect(() => {
            document.addEventListener('click', handleClickOutside);
            return () => document.removeEventListener('click', handleClickOutside);
        }, []);

    // Calculate header left position based on mode and menu state
    const getHeaderStyle = () => {
        if (isReportMode) {
            return { left: isReportMenuCollapsed ? '60px' : '270px' };
        }
        return {};
    };

    return (
        <div>
            <header>
                <div className="topbar d-flex align-items-center" style={getHeaderStyle()}>
                    <div  style={{ height: '45px', background: "transparent", padding: '0 10px', cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}
                            className="d-block d-md-none"
                            onClick={handleLogoClick}
                    >       
                    <img src={logoPath} alt="logo icon" className='company-logo' style={{ display: 'block', margin: '0 auto' }} />
                    </div>

                    <div className="toggle-menu" onClick={toggleMenu}>
                        <i className='fa fa-bars'></i>
                    </div>
                    <nav className="navbar navbar-expand px-0 px-sm-4">
                       {/* <div style={{ display: "flex", gap: "12px", alignItems: "center" }}> */}

                                {/* Portal Toggle Button - Available for all users */}
                                {/* <div
                                    className="portal-toggle-container"
                                    style={{
                                        display: "inline-flex",
                                        background: "#ffffff",
                                        borderRadius: "20px",
                                        padding: "4px",
                                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                        border: "1px solid #e0e0e0"
                                    }}
                                >
                                    <button
                                        className="portal-toggle-btn"
                                        style={{
                                            cursor: "pointer",
                                            fontWeight: "500",
                                            fontSize: "13px",
                                            padding: "6px 16px",
                                            borderRadius: "16px",
                                            border: "none",
                                            background: !isReportMode ? "#f28f34" : "transparent",
                                            color: !isReportMode ? "#ffffff" : "#666666",
                                            transition: "all 0.3s ease",
                                            whiteSpace: "nowrap"
                                        }}
                                        onClick={() => {
                                            if (isReportMode) {
                                                navigate("/dashboard");
                                            }
                                        }}
                                    >
                                        Admin Portal
                                    </button>
                                    <button
                                        className="portal-toggle-btn"
                                        style={{
                                            cursor: "pointer",
                                            fontWeight: "500",
                                            fontSize: "13px",
                                            padding: "6px 16px",
                                            borderRadius: "16px",
                                            border: "none",
                                            background: isReportMode ? "#f28f34" : "transparent",
                                            color: isReportMode ? "#ffffff" : "#666666",
                                            transition: "all 0.3s ease",
                                            whiteSpace: "nowrap"
                                        }}
                                        onClick={() => {
                                            if (!isReportMode) {
                                                navigate("/powerbi-portal");
                                            }
                                        }}
                                    >
                                        Report Portal
                                    </button>
                                </div> */}
                                <div className="quick-links-box" style={{ position: "relative" }}>
                                    {!isReportMode && (hasTicketAccess || empInfo?.role !== "hc_sales" || emp_company.includes("Operis") || seatReservation?.create_permission) && (
                                        <div
                                            className={`quick-links-trigger ${quickAppsOpen ? 'quick-links-trigger-active' : ''}`}
                                            onClick={(e) => { e.stopPropagation(); setQuickAppsOpen(!quickAppsOpen); }}
                                        >
                                            <span>Quick Links</span>
                                            <i className={`fa-solid fa-chevron-down quick-links-chevron ${quickAppsOpen ? 'quick-links-chevron-open' : ''}`}></i>
                                        </div>
                                    )}

                                    {quickAppsOpen && (
                                        <div className="quick-links-panel" onClick={(e) => e.stopPropagation()}>
                                            {hasTicketAccess && (
                                                <div
                                                    className="quick-link-card"
                                                    onClick={() => { navigate("/ticketing"); setQuickAppsOpen(false); }}
                                                >
                                                    <div className="quick-link-card-icon">
                                                        <i className="fa-solid fa-ticket"></i>
                                                    </div>
                                                    <div>
                                                        <div className="quick-link-card-title">Tickets</div>
                                                    </div>
                                                </div>
                                            )}
                                            {(empInfo?.role !== "hc_sales" || emp_company.includes("Operis") || seatReservation?.create_permission) && (
                                                <div
                                                    className="quick-link-card"
                                                    onClick={() => { navigate("/seatbooking"); setQuickAppsOpen(false); }}
                                                >
                                                    <div className="quick-link-card-icon">
                                                        <i className="fa-solid fa-couch"></i>
                                                    </div>
                                                    <div>
                                                        <div className="quick-link-card-title">Seat Reservation</div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                                {/* <div style={{ display: "flex", alignItems: "center", gap: "0" }}>
                                    {hasTicketAccess && !isReportMode && (
                                        <span
                                        className="quick-link-item"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => navigate("/ticketing")}
                                        >
                                        <i className="fa-solid fa-ticket quick-link-icon-white"></i>
                                        Tickets
                                        </span>
                                    )}

                                    {hasTicketAccess && !isReportMode && !isReportMode && (empInfo?.role !== "hc_sales" || emp_company.includes("Operis") || seatReservation?.create_permission) && (
                                        <span className="quick-link-divider"></span>
                                    )}

                                    {!isReportMode && (empInfo?.role !== "hc_sales" || emp_company.includes("Operis") || seatReservation?.create_permission) ? (
                                        <span
                                        className="quick-link-item"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => navigate("/seatbooking")}
                                        >
                                        <i className="fa-solid fa-couch quick-link-icon-white"></i>
                                        Seat Reservation
                                        </span>
                                    ) : null}
                                </div> */}
                                {/* {hasTicketAccess && !isReportMode && (
                                    <span
                                    className="ticketing-link"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => navigate("/ticketing")}
                                    title="Tickets"
                                    >
                                    <i className="fa-solid fa-ticket"></i>                                    
                                    </span>
                                )}

                                {!isReportMode && (empInfo?.role !== "hc_sales" || emp_company.includes("Operis") || seatReservation?.create_permission) ? (
                                    <span
                                    className="ticketing-link"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => navigate("/seatbooking")}
                                    title="Seat Reservation"
                                    >
                                    <i className="fa-solid fa-couch"></i> 

                                    </span>
                                ) : null}
                                </div> */}
                                {/* <div>
                                 {!isReportMode && (hasTicketAccess || empInfo?.role !== "hc_sales" || emp_company.includes("Operis") || seatReservation?.create_permission) && (
                                <div className="quick-apps-box" style={{ position: "relative" }}>
                                    <div
                                        className="quick-apps-trigger"
                                        onClick={(e) => { e.stopPropagation(); setQuickAppsOpen(!quickAppsOpen); }}
                                    >
                                        <i className="fa-solid fa-grip"></i>
                                    </div>

                                    {quickAppsOpen && (
                                        <div className="quick-apps-panel" onClick={(e) => e.stopPropagation()}>
                                            {hasTicketAccess && (
                                                <div
                                                    className="quick-app-item"
                                                    onClick={() => { navigate("/ticketing"); setQuickAppsOpen(false); }}
                                                >
                                                    <div className="quick-app-icon quick-app-icon-red">
                                                        <i className="fa-solid fa-ticket"></i>
                                                    </div>
                                                    <span>Tickets</span>
                                                </div>
                                            )}
                                            {(empInfo?.role !== "hc_sales" || emp_company.includes("Operis") || seatReservation?.create_permission) && (
                                                <div
                                                    className="quick-app-item"
                                                    onClick={() => { navigate("/seatbooking"); setQuickAppsOpen(false); }}
                                                >
                                                    <div className="quick-app-icon quick-app-icon-teal">
                                                        <i className="fa-solid fa-couch"></i>
                                                    </div>
                                                    <span>Seat Reservation</span>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            )}
                        </div> */}
                        <div className="user-menu">
                            <div className="user-box dropdown">
                                    <a
                                    className="d-flex align-items-center nav-link dropdown-toggle dropdown-toggle-nocaret"
                                    href={isTicketing ? "/tickets" : "/dashboard"}
                                    role="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                    >
                                    <div className="user-info ps-3 ">
                                    <i className="fa fa-user dropdown-user-img" aria-hidden="true"></i>
                                    </div>
                                </a>
                                <ul className="dropdown-menu dropdown-menu-end">
                                <li className="dropdown-user-info px-3 py-2 d-flex align-items-center">
                                    <i className="fa fa-user dropdown-user-img" aria-hidden="true"></i>
                                    <div className="ps-2">
                                        <p className="user-name mb-0">{empInfo?.first_name} {empInfo?.last_name}</p>
                                        <p className="designattion mb-0">{empInfo?.emp_no || emp_no}</p>
                                    </div>
                                </li>
                                <li><hr className="dropdown-divider" /></li>
                                <li className="px-3 pt-3 pb-2 dropdown-item-icon">
                                        <i className="fa fa-id-badge"></i>
                                        <span className="designation-text">
                                        {empInfo?.job_title || empInfo?.job_title_name}
                                    </span>
                                </li>

                                {!isReportMode && (
                                    <li className="px-3 pb-2">
                                        <div className="company-select-box" onClick={(e) => {
                                                        e.stopPropagation();
                                                        if (companyMenuOpen) {
                                                            handleCancelCompanies();
                                                        } else {
                                                            openCompanyMenu();
                                                        }
                                                    }}>
                                            <i className="fa fa-building dropdown-icon-self"></i>
                                            <span className="company-selected-text">
                                                {companySelectedLabel}
                                            </span>
                                            <i className="fa fa-chevron-down company-arrow"></i>

                                            {companyMenuOpen && (
                                                <div
                                                    className="custom-company-dropdown-panel"
                                                    onClick={(e) => e.stopPropagation()}
                                                    style={{
                                                        position: "absolute",
                                                        top: "calc(100% + 6px)",
                                                        left: 0,
                                                        right: 0,
                                                        background: "#faf7f2",
                                                        border: "1px solid rgba(0, 0, 0, 0.08)",
                                                        borderRadius: "10px",
                                                        boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.1)",
                                                        padding: "10px",
                                                        zIndex: 20
                                                    }}
                                                >
                                                    <FormikSelectField
                                                        name="company_ids"
                                                        value={pendingCompanyIds}
                                                        onChange={(name, val) => setPendingCompanyIds(val || [])}
                                                        placeholder="Select companies"
                                                        isMulti={true}
                                                        isClearable={true}
                                                        menuPlacement="auto"
                                                    >
                                                        {companies?.map(company => (
                                                            <option key={company.id} value={company.id}>
                                                                {company.company_name}
                                                            </option>
                                                        ))}
                                                    </FormikSelectField>
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "flex-end",
                                                            gap: "8px",
                                                            marginTop: "10px"
                                                        }}
                                                    >
                                                        <button
                                                            type="button"
                                                            onClick={handleCancelCompanies}
                                                            style={{
                                                                cursor: "pointer",
                                                                fontSize: "13px",
                                                                padding: "6px 14px",
                                                                borderRadius: "16px",
                                                                border: "1px solid #e0e0e0",
                                                                background: "transparent",
                                                                color: "#666666"
                                                            }}
                                                        >
                                                            Cancel
                                                        </button>
                                                        <button
                                                            type="button"
                                                            onClick={handleApplyCompanies}
                                                            style={{
                                                                cursor: "pointer",
                                                                fontSize: "13px",
                                                                fontWeight: "500",
                                                                padding: "6px 14px",
                                                                borderRadius: "16px",
                                                                border: "none",
                                                                background: "var(--color-primary-green)",
                                                                color: "#ffffff"
                                                            }}
                                                        >
                                                            Apply
                                                        </button>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </li>
                                )}
                                {!(isMobile && isReportMode) && (
                                    <>
                                        <li className="d-md-none"><hr className="dropdown-divider" /></li>

                                        <li className="px-3 py-2 ">
                                            <div className="portal-toggle-container-mobile">
                                                <button
                                                    className={`portal-toggle-btn ${!isReportMode ? 'portal-toggle-btn-active' : ''}`}
                                                    onClick={() => { if (isReportMode) navigate("/dashboard"); }}
                                                >
                                                    Admin Portal
                                                </button>
                                                <button
                                                    className={`portal-toggle-btn ${isReportMode ? 'portal-toggle-btn-active' : ''}`}
                                                    onClick={() => { if (!isReportMode) window.open("/powerbi-portal", "_blank"); }}
                                                >
                                                    Report Portal
                                                </button>
                                            </div>
                                        </li>
                                        {/* <li className="px-3 py-2 mobile-quick-links d-md-none">
                                            {hasTicketAccess && !isReportMode && (
                                                <div
                                                    className="mobile-quick-link-item"
                                                    onClick={() => navigate("/ticketing")}
                                                >
                                                    <i className="fa-solid fa-ticket me-2"></i>
                                                    Tickets
                                                </div>
                                            )}
                                            {!isReportMode && (empInfo?.role !== "hc_sales" || emp_company.includes("Operis") || seatReservation?.create_permission) ? (
                                                <div
                                                    className="mobile-quick-link-item"
                                                    onClick={() => navigate("/seatbooking")}
                                                >
                                                    <i className="fa-solid fa-couch me-2"></i>
                                                    Seat Reservation
                                                </div>
                                            ) : null}
                                        </li> */}
                                        <li><hr className="dropdown-divider" /></li>
                                    </>
                                )}
                                {isMobile && isReportMode && <li><hr className="dropdown-divider" /></li>}
                                {empInfo?.role === "hc_sales" ? (
                                    <li>
                                        {isReportMode ? (
                                            <span
                                                className="dropdown-item dropdown-item-icon"
                                                style={{ cursor: "pointer" }}
                                                onClick={() => dispatch(setProfileView(true))}
                                            >
                                                <i className="fa fa-user"></i>
                                                <span>Profile</span>
                                            </span>
                                        ) : (
                                            <a className="dropdown-item dropdown-item-icon" href={"/userProfile"}>
                                                <i className="fa fa-user"></i>
                                                <span>Profile</span>
                                            </a>
                                        )}
                                    </li>
                                ) : (
                                    <li>
                                        {isReportMode ? (
                                            <span
                                                className="dropdown-item dropdown-item-icon"
                                                style={{ cursor: "pointer" }}
                                                onClick={() => dispatch(setProfileView(true))}
                                            >
                                                <i className="fa fa-user"></i>
                                                <span>Profile</span>
                                            </span>
                                        ) : (
                                            <a className="dropdown-item dropdown-item-icon" href={"/employees/" + empInfo?.user_id}>
                                                <i className="fa fa-user"></i>
                                                <span>Profile</span>
                                            </a>
                                        )}
                                    </li>
                                )}
                                <li><hr className="dropdown-divider" /></li>
                                <li>
                                    <a className="dropdown-item dropdown-item-icon" href="/logout">
                                        <i className="fa fa-sign-out-alt"></i>
                                        <span>Logout</span>
                                    </a>
                                </li>
                            </ul>
                             </div>
                        </div>
                    </nav>
                </div>
            </header>
        </div>
    )
}

export default Header